var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.6934,
    cy: 8,
    r: 5,
    fill: "#222222"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3449 19.4054C19.8977 19.2902 20.2269 18.7117 19.9522 18.2183C19.3466 17.1307 18.3926 16.1749 17.1722 15.4465C15.6004 14.5085 13.6745 14 11.6933 14C9.71213 14 7.78628 14.5085 6.21448 15.4465C4.99405 16.1749 4.04002 17.1307 3.43444 18.2183C3.15974 18.7117 3.48898 19.2902 4.04179 19.4054V19.4054C9.0886 20.4572 14.2981 20.4572 19.3449 19.4054V19.4054Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profile-icon.ea33bf8a1bb0baa16137ef8973aaf374.svg";
export { ForwardRef as ReactComponent };